export const COMMENT_ADDED = "commentAdded";
export const COMMENT_UPDATED = "commentUpdated";
export const COMMENT_REMOVED = "commentRemoved";
export const COMMENT_RESTORED = "commentRestored";
